import { Card } from '../components/Card'
import { EmailLoginForm } from '../components/EmailLoginForm'
import { SsoSection } from '../components/SsoSection'

/**
 * Main login entry page — SSO (Microsoft/Google) + email entry.
 * Ported from the web client's `/login` page.
 */
export function LoginEntryPage() {
  return (
    <Card>
      {/* 1. Header */}
      <header className="flex flex-col gap-1.5">
        <h1 className="text-2xl font-bold tracking-tight text-brand-dark-text">Welcome</h1>
        <p className="text-sm text-brand-copyright">Use your company Microsoft or Google account</p>
      </header>

      {/* 2. Single Sign-On (SSO) — owns its own error alerts */}
      <SsoSection />

      {/* 3. Form Separator */}
      <div className="flex items-center gap-4 text-xs text-brand-muted tracking-widest">
        <div className="flex-1 h-px bg-brand-border-light" />
        <span>or</span>
        <div className="flex-1 h-px bg-brand-border-light" />
      </div>

      {/* 4. Traditional Email Form */}
      <EmailLoginForm />

      {/* 5. Footer Disclaimer */}
      <footer className="text-center">
        <p className="text-[11px] text-brand-muted leading-normal">
          Access is managed by your AMLiQ administrator.
        </p>
      </footer>
    </Card>
  )
}
